$(function(){
    // openZoom();
    cartDrawerUpt();
    // setInterval(function(){
      
    // },3000);
    if (isCartPage()) {
      runInitialCartPagePromo();
    } else if (cartNeedsPromoAction()) {
      scheduleCartSync(null);
    }

    document.addEventListener('line-item:will-change', function() {
      showCartLoading();
    }, true);

    document.addEventListener('cart:prepare-bundled-sections', function(evt) {
      if (!evt.detail?.sections) {
        return;
      }
  
      const mainCartSectionId = getMainCartSectionId();
      if (mainCartSectionId && evt.detail.sections.indexOf(mainCartSectionId) === -1) {
        evt.detail.sections.push(mainCartSectionId);
      }
  
      const cartDrawerSectionId = getCartDrawerSectionId();
      if (cartDrawerSectionId && evt.detail.sections.indexOf(cartDrawerSectionId) === -1) {
        evt.detail.sections.push(cartDrawerSectionId);
      }
    });
  
    document.addEventListener('cart:change', function(evt) {
      const sectionId = isCartPage() ? getMainCartSectionId() : getCartDrawerSectionId();
      const sectionHtml = sectionId ? evt.detail?.cart?.sections?.[sectionId] : null;
      scheduleCartSync(sectionHtml || null);
  
      setTimeout(function() {
        checkAndSyncBundledItems();
      }, 500);
    });

    $(document).on('cart:refresh', function() {
      scheduleCartSync(null);
    });

    document.addEventListener('cart:updated', function() {
      scheduleCartSync(null);
      setTimeout(function() {
        checkAndSyncBundledItems();
      }, 500);
    });

    document.addEventListener('ajaxProduct:added', function() {
      scheduleCartSync(null);
      setTimeout(function() {
        checkAndSyncBundledItems();
      }, 500);
    });
    onloadMulticolumnHover();
    onclickGwp();
    onclickRemoveGwp();
    onloadUpdateGwp();
    pdpClickVariant();
    onloadUpdateVarImage();
    onloadSubscriptionBenefit();
    shippingBarUpdate();
    onloadUpdateImgGallery();
    onloadNewNavHover();
    cartSubscriptionNote();
    setTimeout(function() {
      checkMultiGWP();
      checkAndSyncBundledItems();
    }, isCartPage() ? 1500 : 0);
    setupVariantOption();
    controlVariantOption();
    onloadMultiColumnFlickity();
    setupMultiColumnIntersectionObserver();

  if (location.href.includes('/products')) {
    onloadUpdateButtonPrice();
  }
});

isCartPage = () => {
  return window.themeVariables?.settings?.pageType === 'cart'
    || document.body.classList.contains('template-cart');
};

getCartDrawerSectionId = () => {
  const section = document.querySelector('.shopify-section--cart-drawer');
  if (section?.id) {
    return section.id.replace('shopify-section-', '').replace(' ', '');
  }
  return 'cart-drawer';
};

getMainCartSectionId = () => {
  const section = document.querySelector('.shopify-section--main-cart');
  if (section?.id) {
    return section.id.replace('shopify-section-', '').replace(' ', '');
  }
  return null;
};

showCartLoading = () => {
  if ($('.jsc-page-loading').length === 0) {
    $('body').prepend(`<div class="jsc-page-loading">
      <div class="jsc-spinner-container">
        <div class="jsc-loading-text">Updating your cart...</div>
      </div>
    </div>`);
  }
};

hideCartLoading = () => {
  $('.jsc-page-loading').remove();
};

hasPromoHookValue = (selector) => {
  return Array.from(document.querySelectorAll(selector)).some(function(el) {
    return (el.value || '').trim().length > 0;
  });
};

cartNeedsPromoAction = () => {
  return (
    hasPromoHookValue('.jsc-cart-gift-add') ||
    hasPromoHookValue('.jsc-cart-gift-remove') ||
    hasPromoHookValue('.jsc-cart-gift-stackable') ||
    hasPromoHookValue('.jsc-cart-gift-remove-stackable') ||
    hasPromoHookValue('.jsc-cart-gift-wsl') ||
    hasPromoHookValue('.jsc-cart-gift-remove-wsl')
  );
};

collectPromoLineKeys = (selector) => {
  const keys = [];

  document.querySelectorAll(selector).forEach(function(el) {
    const key = (el.value || '').trim();
    if (key) {
      keys.push(key);
    }
  });

  return keys;
};

collectPromoAdditions = () => {
  if (sessionStorage.getItem('FreeGift') === 'Remove') {
    return [];
  }

  const additions = [];
  const hasWslAdd = hasPromoHookValue('input.jsc-cart-gift-wsl:not(.jsc-cart-gift-remove-wsl)');

  document.querySelectorAll('.jsc-cart-gift-add').forEach(function(el) {
    const variantId = parseInt(el.value, 10);
    const promoNo = el.getAttribute('data-promo');

    if (!variantId || !promoNo) {
      return;
    }

    const properties = {
      '_Cart_GWP': 'Free Gift',
      '_Cart_Gift': promoNo
    };

    additions.push({ variantId: variantId, properties: properties });
  });

  if (hasWslAdd) {
    document.querySelectorAll('input.jsc-cart-gift-wsl').forEach(function(el) {
      if (el.classList.contains('jsc-cart-gift-remove-wsl')) {
        return;
      }

      const variantId = parseInt(el.value, 10);
      const promoNo = el.getAttribute('data-promo');

      if (!variantId || !promoNo) {
        return;
      }

      additions.push({
        variantId: variantId,
        properties: {
          '_Cart_GWP': 'Free Gift',
          '_Cart_Gift_WSL': promoNo
        }
      });
    });
  }

  document.querySelectorAll('.jsc-cart-gift-stackable').forEach(function(el) {
    const variantId = parseInt(el.value, 10);
    const promoNo = el.getAttribute('data-promo');

    if (!variantId || !promoNo) {
      return;
    }

    additions.push({
      variantId: variantId,
      properties: {
        '_Cart_GWP': 'Free Gift',
        '_Cart_Gift_Stackable': promoNo
      }
    });
  });

  return additions;
};

executePromoCartActions = async () => {
  const lineKeys = [
    ...collectPromoLineKeys('.jsc-cart-gift-remove'),
    ...collectPromoLineKeys('.jsc-cart-gift-remove-wsl'),
    ...collectPromoLineKeys('.jsc-cart-gift-remove-stackable')
  ];
  const uniqueLineKeys = [...new Set(lineKeys)];
  const additions = collectPromoAdditions();

  if (uniqueLineKeys.length === 0 && additions.length === 0) {
    return false;
  }

  if (uniqueLineKeys.length > 0) {
    const updates = {};
    uniqueLineKeys.forEach(function(key) {
      updates[key] = 0;
    });

    const removeResponse = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });

    if (!removeResponse.ok) {
      console.error('Failed to remove GWP line items');
    }
  }

  for (const addition of additions) {
    const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: addition.variantId,
          quantity: 1,
          properties: addition.properties
        }]
      })
    });

    if (!addResponse.ok) {
      console.error('Failed to add GWP line item');
    }
  }

  return true;
};

updateCartCountFromSection = (container) => {
  const scope = container || document;
  const cartCountElement = document.querySelector('cart-count');
  const updatedCount = scope.querySelector?.('cart-count')?.textContent?.trim();
  if (cartCountElement && updatedCount) {
    cartCountElement.textContent = updatedCount;
  }
};

applyCartDrawerSectionHtml = (sectionHtml) => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || !sectionHtml) return false;

  const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const updatedDrawer = parsed.querySelector('#cart-drawer') || parsed.querySelector('cart-drawer');
  if (!updatedDrawer) return false;

  const updatedLineItems = updatedDrawer.querySelector('.cart-drawer__line-items');
  const currentLineItems = cartDrawer.querySelector('.cart-drawer__line-items');

  if (updatedLineItems && currentLineItems) {
    currentLineItems.innerHTML = updatedLineItems.innerHTML;
    const updatedFooter = updatedDrawer.querySelector('[slot="footer"]');
    const currentFooter = cartDrawer.querySelector('[slot="footer"]');
    if (updatedFooter && currentFooter) {
      currentFooter.replaceChildren(...updatedFooter.childNodes);
    }
  } else {
    cartDrawer.replaceChildren(...updatedDrawer.childNodes);
  }

  updateCartCountFromSection(updatedDrawer);
  return true;
};

refreshCartDrawer = () => {
  const sectionId = getCartDrawerSectionId();
  return fetch(`${window.Shopify.routes.root}?section_id=${sectionId}`)
    .then(res => res.text())
    .then(html => applyCartDrawerSectionHtml(html))
    .catch(err => {
      console.error('Error refreshing cart drawer:', err);
    });
};

applyMainCartSectionHtml = (sectionHtml) => {
  const section = document.querySelector('.shopify-section--main-cart');
  if (!section || !sectionHtml) return false;

  const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const updatedSection = parsed.querySelector('.shopify-section--main-cart')
    || parsed.getElementById(section.id)
    || parsed.querySelector('[id^="shopify-section-"]');
  if (!updatedSection) return false;

  section.innerHTML = updatedSection.innerHTML;
  updateCartCountFromSection(updatedSection);
  onclickGwp();
  onclickRemoveGwp();
  onloadUpdateGwp();
  return true;
};

refreshMainCart = () => {
  const sectionId = getMainCartSectionId();
  if (!sectionId) return Promise.resolve();

  return fetch(`${window.Shopify.routes.root}?section_id=${sectionId}`)
    .then(res => res.text())
    .then(html => applyMainCartSectionHtml(html))
    .catch(err => {
      console.error('Error refreshing cart page:', err);
    });
};

var cartJsRequestCount = 0;
var isCartSyncInProgress = false;
var syncCartTimer = null;
var pendingCartSyncHtml = null;

runInitialCartPagePromo = async () => {
  if (!cartNeedsPromoAction()) {
    return;
  }

  showCartLoading();

  try {
    const cartJsBefore = cartJsRequestCount;
    gwpTierFunction(false);
    await executePromoCartActions();

    if (cartJsRequestCount > cartJsBefore) {
      finishCartSync();
      return;
    }

    await refreshMainCart();
    finishCartSync();
  } catch (error) {
    console.error('Error running initial cart promo:', error);
    finishCartSync();
  }
};

runPromoIfNeeded = async () => {
  const cartJsBefore = cartJsRequestCount;
  let promoChanged = false;

  gwpTierFunction(false);

  if (cartNeedsPromoAction()) {
    promoChanged = await executePromoCartActions();
  }

  return promoChanged || cartJsRequestCount > cartJsBefore;
};

finishCartSync = () => {
  hideCartLoading();
  isCartSyncInProgress = false;

  if (pendingCartSyncHtml !== null) {
    const nextSectionHtml = pendingCartSyncHtml;
    pendingCartSyncHtml = null;
    scheduleCartSync(nextSectionHtml);
  }
};

refreshCartSurface = async () => {
  if (isCartPage() && getMainCartSectionId()) {
    await refreshMainCart();
    return;
  }

  if (document.querySelector('cart-drawer')) {
    await refreshCartDrawer();
  }
};

applyCartSectionHtml = (sectionHtml) => {
  if (isCartPage() && getMainCartSectionId()) {
    return applyMainCartSectionHtml(sectionHtml);
  }
  
  if (document.querySelector('cart-drawer')) {
    return applyCartDrawerSectionHtml(sectionHtml);
  }
  
  return false;
};

syncCartAndPromo = async (sectionHtml) => {
  if (isCartSyncInProgress) {
    pendingCartSyncHtml = sectionHtml;
    return;
  }

  isCartSyncInProgress = true;
  showCartLoading();

  try {
    let sectionApplied = false;
  
    if (sectionHtml) {
      sectionApplied = applyCartSectionHtml(sectionHtml);
    }
  
    if (!sectionApplied) {
      await refreshCartSurface();
    }

    const cartJsBefore = cartJsRequestCount;
    const promoChanged = await runPromoIfNeeded();

    if (promoChanged) {
      await refreshCartSurface();
    }
  
    if (cartJsRequestCount > cartJsBefore) {
      return;
    }
  
    finishCartSync();
  } catch (error) {
    console.error('Error syncing cart:', error);
    finishCartSync();
  }
};

scheduleCartSync = (sectionHtml) => {
  clearTimeout(syncCartTimer);
  syncCartTimer = setTimeout(function() {
    syncCartAndPromo(sectionHtml);
  }, 50);
};

scheduleCartDrawerSync = scheduleCartSync;

handleCartJsRequestComplete = async () => {
  cartJsRequestCount = Math.max(0, cartJsRequestCount - 1);
  if (cartJsRequestCount > 0) {
    return;
  }

  try {
    if (isCartSyncInProgress) {
      if (cartNeedsPromoAction()) {
        await runPromoIfNeeded();
      }
      await refreshCartSurface();
      finishCartSync();
      return;
    }
  
    if (cartNeedsPromoAction()) {
      await runPromoIfNeeded();
    }
  
    await refreshCartSurface();
  } catch (error) {
    console.error('Error refreshing cart after CartJS update:', error);
    if (isCartSyncInProgress) {
      finishCartSync();
    }
  }

  hideCartLoading();
};

cartDrawerUpt = () => {
    $(document).on('cart.requestStarted', function() {
      cartJsRequestCount += 1;
      showCartLoading();
    });

    $('#cart-drawer').parent().addClass('shopify-section--cart-drawer');

    $(document).on('cart.requestComplete', function() {
      handleCartJsRequestComplete();
    });
}

masterPromo = (isDrawer) =>{
  gwpTierFunction(isDrawer);
  cartGift();
}

//Start GWP Tier promo
gwpTierFunction = (isOpenDrawer) =>{
  console.log('gwpTierFunction');
  // $.when($.getJSON('/cart.js', function(cart) {
  
  // })).then(function(cart){
    var $deleteEle = $('.jsc-remove-gwp');

    if ($deleteEle.length > 0) { // remove previous tier product first
        $deleteEle.each(function() {
          var $vid = $(this).val();
          var $qty = 0;
          console.log('remove tier',$vid);
          cartJSUpdateQuery($vid, $qty, {}, false);
        });
    }
    else { // add current tier product after previous tier product is removed
      var $ele = $('._cartGwp');

      $ele.each(function() {
        var $gwpcart_product = {};
        var $vid = parseInt($(this).attr('data-vid'));
        var $tierNo = $(this).attr('data-tier');
        var $tierCol = $(this).attr('data-col');
        $gwpcart_product['GWP Tier '+$tierNo] = true;
        $gwpcart_product['_Cart_GWP'] = 'Free Gift';
        if ( $tierCol ) {
          $gwpcart_product['_GWP_col'] = $tierCol;
        }
        
        if ($(this).length > 0) {
          cartJSAddQuery($vid, 1, $gwpcart_product, false);
        }
      });
    }
  
  // });

}
removeTierGift = () =>{
  var $deleteEle = $('.jsc-remove-gwp');

  if ($deleteEle.length > 0) {
      $deleteEle.each(function() {
        var $vid = $(this).val();
        var $qty = 0;
        console.log('remove tier',$vid);
        cartJSUpdateQuery($vid, $qty, {}, false);
      });
  }

}
//End GWP Tier promo

//start: gwp
cartGift = () => {
  return executePromoCartActions();
}

removeFreeGift = (e,varID) =>{
    sessionStorage.setItem("FreeGift", "Remove");
    var varID = varID;
    cartJSUpdateQuery(varID, 0);
}
onclickGwp = () => {
  
  var tabs = document.getElementsByClassName("jsc-gwp-grid-atc cursor");
  var closeBtn = document.getElementsByClassName("jsc-minus-close");
  // cartJSUpdateQuery(44764225503445, 0, {}, true);

  for (var i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener("click", function() {
      // console.log('gwp click 1');
      $(this).addClass('jsc-not-allowed');
      $(this).removeClass('cursor');
      $(this).parents('.horizontal-product').siblings('.horizontal-product').find('.jsc-gwp-grid-atc ').removeClass('cursor');
      $(this).parents('.horizontal-product').siblings('.horizontal-product').find('.jsc-gwp-grid-atc ').addClass('jsc-not-allowed');

      var $gwpAdded = $(this).attr('data-gwp-added');
      var $vid = $(this).attr('data-prod-id');
      var $obj = {};
      var $promoNo = $(this).attr('data-promo');
      $(this).attr('data-gwp-added','true');

      $obj['_Cart_Gift_Manual'] = $promoNo;
      $obj['_Cart_GWP_Manual'] = 'Free Gift';
      if ($gwpAdded == 'false' ) {
          // if (removeGift != 'Remove') {
          // cartJSAddQuery($vid,1,$obj,true);
          // }
          $(this).find('.button').html('Added!');
          cartJSAddQuery($vid,1,$obj,true);
      }
    });
  }
}
onclickRemoveGwp = () => {
  
  var tabs = document.getElementsByClassName("jsc-gwp-remove-from-drawer");

  var $elem = $('.jsc-cart-gift-manual-remove');
  var $key = $elem.val();

  if ($elem.length > 0) {
      cartJSUpdateQuery($key, 0, {}, true);
  }
  // cartJSUpdateQuery(44764225503445, 0, {}, true);

  for (var i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener("click", function() {
      var $key = $(this).attr('data-line-key');

      cartJSUpdateQuery($key, 0, {}, true);
    });
  }
}
onloadUpdateGwp = () => {
  var $enable_in_cartpage = $('.jsc-choose-gwp-container').attr('data-enable-in-cartpage');

  if ($enable_in_cartpage != 'true') {
    $('.jsc-choose-gwp-container').hide();
  }
}

checkMultiGWP = () => {
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    var cartItems = cart.items;
    var removeList = {};
    
    for (var item of cartItems) {
      var properties = item.properties;
      var qty = item.quantity;
      var key = item.key;
      if ((properties['_Cart_GWP'] == 'Free Gift') && qty > 1) {
        removeList[key] = 1;
      }
    }

    if (Object.keys(removeList).length > 0) {
        cartJSUpdateQuantity(removeList);
    }
  });
}

// Unified function to check orphaned bundled items and sync parent-child quantities
checkAndSyncBundledItems = () => {
  console.log('checkAndSyncBundledItems:started!');
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      var cartItems = cart.items;
      var updateList = {};
      var removeList = {};
      var bundleIds = new Set();
      var mainBundleItems = {}; // bundleId -> {key, quantity}
      
      // First pass: collect all main bundle items (parents) and their quantities
      for (var item of cartItems) {
        var properties = item.properties || {};
        if (properties['_BundleId'] && !properties['_Is_Bundled']) {
          var bundleId = properties['_BundleId'];
          bundleIds.add(bundleId);
          mainBundleItems[bundleId] = {
            key: item.key,
            quantity: item.quantity
          };
        }
      }
      
      // Second pass: process bundled items (children)
      for (var item of cartItems) {
        var properties = item.properties || {};
        if (properties['_Is_Bundled'] == 'true') {
          var bundleId = properties['_BundleId'];
          
          // Check if parent exists
          if (!bundleId || !bundleIds.has(bundleId)) {
            // This bundled item has no parent, mark for removal
            removeList[item.key] = 0;
          } else {
            // Parent exists, sync quantity
            var mainItem = mainBundleItems[bundleId];
            if (mainItem) {
              if (mainItem.quantity === 0) {
                // Parent quantity is 0, remove child
                removeList[item.key] = 0;
              } else if (item.quantity !== mainItem.quantity) {
                // Child quantity doesn't match parent, update it
                updateList[item.key] = mainItem.quantity;
              }
            }
          }
        }
      }
      
      // Track how many updates we need to wait for
      var pendingUpdates = 0;
      var hasUpdates = false;
      
      // Function to refresh cart drawer after all updates complete
      var refreshCartDrawerAfterBundleSync = function() {
        pendingUpdates--;
        if (pendingUpdates === 0 && hasUpdates) {
          scheduleCartSync(null);
        }
      };
      
      // Apply all updates
      if (Object.keys(updateList).length > 0) {
        console.log('Syncing bundled items quantities:', updateList);
        hasUpdates = true;
        pendingUpdates++;
        cartJSUpdateQuantity(updateList, refreshCartDrawerAfterBundleSync);
      }
      
      if (Object.keys(removeList).length > 0) {
        console.log('Removing orphaned/zero-quantity bundled items:', removeList);
        hasUpdates = true;
        pendingUpdates++;
        cartJSUpdateQuantity(removeList, refreshCartDrawerAfterBundleSync);
      }
      
      // If no updates were needed, we're done
      if (!hasUpdates) {
        console.log('No bundle sync updates needed');
      }
      console.log('checkAndSyncBundledItems:completed!');
    })
    .catch(error => {
      console.error('Error checking and syncing bundled items:', error);

      console.log('checkAndSyncBundledItems:error!');
    });
}
//end: gwp

jscClickATC_pdp = () => {
  setTimeout(function(){
    masterPromo(false);
  },3000);

}

jscClickRemove_cart = () => {
  // masterPromo is now handled in cart updates
}

cartJSUpdateQuantity = (items, onComplete) => {
    CartJS.updateItemQuantitiesById(items,
    {
      "success": function(data, textStatus, jqXHR) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          beforeSend: function() {
            console.log('before');
          },
          success: function(cart) {
            // Call optional completion callback
            if (typeof onComplete === 'function') {
              onComplete(cart);
            }
          }
        });
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
        // Call completion callback even on error
        if (typeof onComplete === 'function') {
          onComplete(null);
        }
      }
    });
}

cartJSAddQuery = (vid, qty, obj) => {
    // Cart js add item, success callback, error callback
  
    CartJS.addItem(vid, qty, obj,
    {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          beforeSend: function() {
            console.log('before');
            // to call theme cart

          },
          success: function(cart) {
            /*
            getThis.element.dispatchEvent(new CustomEvent('product:added', {
              bubbles: isOpenDrawer,
              detail: {
                variant: vid,
                quantity: qty
              }
            }));
            */
          }
        });
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
      }
    });
}
  
cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
    // Cart js add item, success callback, error callback
  
    CartJS.updateItemById(vid, qty, obj,
    {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          beforeSend: function() {
            console.log('before');
          },
          success: function(cart) {
            /*
            getThis.element.dispatchEvent(new CustomEvent('product:added', {
              bubbles: isOpenDrawer,
              detail: {
                variant: vid,
                quantity: qty
              }
            }));
            */
          }
        });
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
      }
    });
}

// Removed syncBundledItems and syncBundledItemsByBundleId - functionality merged into checkAndSyncBundledItems

//start: custom multicolumn hover image
onHoverDisplayText = (e) => {
  console.log('jsc hover');
  // $('body').css('background','red');
}

outHoverHideText = (e) => {
  console.log('jsc done hover');
}
onloadMulticolumnHover = () => {
  console.log('onload hover1',$(window).width());

  if ($(window).width() > 799) {
    $('.jsc-multicolumn-block-image-container').hover(function(){
      // console.log($(window).width());
      $(this).find('.jsc-multicolumn-image-text-hover').removeClass('d-none');
      }, function(){
      $(this).find('.jsc-multicolumn-image-text-hover').addClass('d-none');
    });
  }
  else {
    //uncomment this if want to display 1 hover content at a time
    // $('.jsc-multicolumn-block-image-container').hover(function(){
    //   //do nothing
    //   }, function(){
    //   $(this).find('.jsc-multicolumn-image-text-hover').addClass('d-none');
    //   $(this).find('.jsc-tablet-down-hover-container .jsc-minus-close').addClass('d-none');
    //   $(this).find('.jsc-tablet-down-hover-container .jsc-plus-open').removeClass('d-none');
    // });
  }

}
//end: custom multicolumn hover image
//start: open zoom
openZoom = () => {
  var zoom = document.getElementsByClassName("ZoomHover");
  for (var i = 0; i < zoom.length; i++) {
    zoom[i].addEventListener("click", function() {
      console.log($(this));
      $(this).addClass('active-tab');
      $(this).siblings('.product-gallery__zoom').find('button').click();
    });
  }
}
//end: open zoom

//start: click variant pdp
pdpClickVariant = () => { //to update the price of variant selected
  var zoom = document.getElementsByClassName("jsc-block-swatch");

  for (var i = 0; i < zoom.length; i++) {
    zoom[i].addEventListener("click", function() {
            
      var $this_var_tab = $(this).parents('.product-info__variant-picker');
      setTimeout(function(){
        var $this_price_tab = $this_var_tab.siblings('.recharge-subscription-widget').find('.subscription-radio .price-label').text();
        
        if ($this_price_tab.length > 0) {
          $('.jsc-alt-price-pdp').text($this_price_tab);
        //  console.log(this_price_tab);
        }
        
      },300);

    });
  }
  
}
//end: click variant pdp

//start: update var image in product gallery
onloadUpdateVarImage = () => {
  // var $pageUrl = window.location.href;
  // var $currentVarId = $pageUrl.split('variant=')[1];
  var $selectedVar = $('.product-info__variant-picker').find('.variant-picker__option-values .jsc-selected-swatch');
  var mediaID = $selectedVar.attr('data-media-id');
  // alert(mediaID);
  var $media_gallery = $('.jsc-product-gallery__media');
  var $dummy_media_gallery = $('.jsc-dummy-main-image-div');

  if ($dummy_media_gallery.length > 0) {
    $media_gallery.each(function(){
      var $this_media_id = $(this).attr('data-media-id');
      if ($this_media_id == mediaID ) {
        
        var $this_src = $(this).find('.jsc-pdp-image').attr('src');
        var $this_srcset = $(this).find('.jsc-pdp-image').attr('srcset');
        // alert($this_srcset);
        
          $dummy_media_gallery.find('.jsc-pdp-image').attr('src',$this_src);
          $dummy_media_gallery.find('.jsc-pdp-image').attr('srcset',$this_srcset);
          // setTimeout(function(){},1000);
        
      }
    })
  }
}
jscUpdateVarImage = (e) => {
  // alert(mediaID);
  setTimeout(function() {
    const checkedInputs = $('input:checked[name^="option"]');
      let selector = '.jsc-variant-details';

      checkedInputs.each(function () {
        const name = $(this).attr('name');
        const value = $(this).val();
        selector += `[data-${name}="${value}"]`;
      });

      const $matchingVariant = $(selector);
      const matchedMediaId = $matchingVariant.attr('data-media-id');

      var $media_gallery = $('.jsc-product-gallery__media');
      var $dummy_media_gallery = $('.jsc-dummy-main-image-div');

      if ($dummy_media_gallery.length > 0) {
        $media_gallery.each(function(){
          var $this_media_id = $(this).attr('data-media-id');
          //$(this).removeClass('d-none');
          if ($this_media_id == matchedMediaId ) {
            //$(this).addClass('d-none');
            var $this_src = $(this).find('.jsc-pdp-image').attr('src');
            var $this_srcset = $(this).find('.jsc-pdp-image').attr('srcset');
            // alert($this_srcset);
            
            $dummy_media_gallery.find('.jsc-pdp-image').attr('src',$this_src);
            $dummy_media_gallery.find('.jsc-pdp-image').attr('srcset',$this_srcset);
            // setTimeout(function(){},1000);
            
          }
        })
      }
  }, 100);
}
//end: update var image in product gallery

//start: hide & show the subscription benefit in pdp
onloadSubscriptionBenefit = () => {
  var $subscription_benefit = $('.product-info__text.jsc-subscription-benefits');

  if ($subscription_benefit.length > 0) {

    setTimeout(function(){
      var $subscription_price = $('.rc-radio--active.subscription-radio');

      if ($subscription_price.length > 0) {
        $subscription_benefit.removeClass('d-none');
      } else {
        $subscription_benefit.addClass('d-none');
      }

      $('.rc-radio.onetime-radio').click(function(){
        $subscription_benefit.addClass('d-none');
      });
      $('.rc-radio.subscription-radio').click(function(){
        $subscription_benefit.removeClass('d-none');
      });

    },1000);
    
  }
}
//end: hide & show the subscription benefit in pdp

//Start - Shipping bar
shippingBarUpdate = () =>{
  var $local_shipping_bar = $('.free-shipping-bar');
  setTimeout(function(){
    var $local_min = parseInt($local_shipping_bar.attr('threshold'));
    var $cart_total = $local_shipping_bar.attr('total-price');
    var $intl_min = parseInt($local_shipping_bar.attr('data-intl-threshold'));
    var $currency_symbol = $local_shipping_bar.attr('data-currency-symbol');
    var $currency_code = $local_shipping_bar.attr('data-currency-code');
    var $local_progress_bar = $('.progress-bar');

    if (!isNaN($intl_min)) {
      if ($cart_total >= $intl_min) {
        //alert('intl shipping reached' + $cart_total + ',' + $intl_min );
        // $('.jsc-free-shipping-bar').show();
        // $('.jsc-intl-shipping-reached').show();
        // $('.jsc-local-shipping-reached').hide();
        // $('.jsc-intl-shipping-text').hide();

        var $intl_cart_free_shipping_reached_message_2_script = document.querySelector('[data-intl-cart-free-shipping-reached-message-2]');
        var $update_text = $intl_cart_free_shipping_reached_message_2_script ? JSON.parse($intl_cart_free_shipping_reached_message_2_script.textContent) : 'Your shipping is on us!';

        $local_shipping_bar.find('span').html($update_text);
        $local_progress_bar.attr('aria-valuemax',$intl_min);
      }
      else if ($cart_total >= $local_min) {
        // alert('local shipping reached' + $cart_total + ',' + $local_min );
        var $intl_balance = $intl_min - $cart_total;
        var $format_$intl_balance = Shopify.formatMoney($intl_balance, $('body').data('money'));
        var $replace_intl_balance = $format_$intl_balance.replace('undefined','');
        $('.jsc-intl-shipping-target').text($format_$intl_balance.replace('undefined',''));

        // $('.jsc-free-shipping-bar').show();
        //$('.jsc-intl-shipping-reached').hide();
        //$('.jsc-local-shipping-reached').show();
        //$('.jsc-intl-shipping-text').show();
        var $intl_balance_msg = $currency_code + ' ' + $currency_symbol + $replace_intl_balance;
        var $intl_cart_free_shipping_reached_message_script = document.querySelector('[data-intl-cart-free-shipping-reached-message]');
        var $intl_cart_free_shipping_reached_message = $intl_cart_free_shipping_reached_message_script ? JSON.parse($intl_cart_free_shipping_reached_message_script.textContent) : 'Your order qualifies for free domestic shipping to Singapore. Spend {{ intl_balance_msg }} more to enjoy free international shipping!';
        var $update_text = $intl_cart_free_shipping_reached_message.replace('{{ intl_balance_msg }}', $intl_balance_msg);

        $local_shipping_bar.find('span').html($update_text);
        $local_progress_bar.attr('aria-valuemax',$intl_min);
      }
      else if ($cart_total < $local_min) {
        // alert('local shipping target' + $cart_total + ',' + $local_min );
        $('.free-shipping-bar').show(); //show default free shipping section
        // $('.jsc-free-shipping-bar').hide();
        $local_progress_bar.attr('aria-valuemax',$local_min);
      }
      else {
      }
    }

  },500);
  
}
//End - Shipping bar

// start: new mega menu for Shop
jscMegaMenuTab = (e) => {
  var tab_siblings = $(e).siblings('.jsc-second-level-nav');
  tab_siblings.find('.is-active').removeClass('is-active'); //close other accordion

  var currentIsActive = $(e).find('.accordion__header').hasClass('is-active');
  $(e).find('> *').removeClass('is-active');

  if(currentIsActive != true) {
    $(e).find('.accordion__header').addClass('is-active');
    $(e).find('.accordion__body').addClass('is-active');
  }
}
// end: new mega menu for Shop


// start: rebuild image gallery in pdp
onloadUpdateImgGallery = () => {
  var $hidden_gallery_grid_status = $('.jsc-hidden-media-input').attr('data-split-variant');

  if ($hidden_gallery_grid_status == 'true') {
    if ($(window).width() > 799) {
      setTimeout(function(){
        $('.product-gallery__media-list').empty();
        var $hidden_gallery_grid = $('.jsc-hidden-media-input .jsc-hidden-media-each');
        var color = $('.jsc-option-Color').attr('data-option-val');
        var $media_sequence = 0;
        // alert(color);
        $hidden_gallery_grid.each(function(){
          var $this_media_alt = $(this).attr('data-media-alt');
          
          if ($this_media_alt == color) {
            $media_sequence += 1;
            $(this).clone().removeClass('jsc-hidden-media-each').addClass('product-gallery__media').attr('data-media-seq',$media_sequence).appendTo('.product-gallery__media-list');
          }
        });
      },100);
    } else {
      
    }
    
  }
  
}
jscClickColorVar = (e,color) => {
  if ($(window).width() > 799) {
    $('.product-gallery__media-list').empty(); //clear media carousel
    var $hidden_gallery_grid = $('.jsc-hidden-media-input .jsc-hidden-media-each');
    var $media_sequence = 0;

    $hidden_gallery_grid.each(function(){
      var $this_media_alt = $(this).attr('data-media-alt');
      if ($this_media_alt == color) {
        $media_sequence += 1;
        $(this).clone().removeClass('jsc-hidden-media-each').addClass('product-gallery__media').attr('data-media-seq',$media_sequence).appendTo('.product-gallery__media-list');
      }
    });
  } else {
    
  }
  
}
// end: rebuild image gallery in pdp
 
//start: product grid custom quick buy 
var jscClickQuickBuy = (e) => { 
  var variant_id = $(e).attr('data-var-id'); 
  var qty = 1; 
  var selling_plan = $(e).attr('data-selling-plan'); 
 
  var data = { 
    id: variant_id, 
    quantity: qty, 
    selling_plan: selling_plan, 
  }; 
  
  jQuery.ajax({ 
    type: "POST", 
    url: "/cart/add.js", 
    data: data, 
    dataType: "json", 
    success: function () { 
      // Fetch the updated cart drawer section 
      $.ajax({ 
        url: "/?section_id=cart-drawer", 
        type: "GET", 
        dataType: "html", 
        success: function (carthtml) { 
          // Update the cart drawer content 
          const cartDrawer = document.querySelector("cart-drawer"); 
          if (cartDrawer) { 
            cartDrawer.innerHTML = $(carthtml).find("cart-drawer").html(); 
   
            // Open the cart drawer 
            if (typeof cartDrawer.show === "function") { 
              cartDrawer.show(); 
            } 
          } 
 
          // Update the cart count 
          const cartCountElement = document.querySelector("cart-count"); 
          const updatedCount = $(carthtml).find("cart-count").text().trim(); 
 
          if (cartCountElement) { 
            cartCountElement.textContent = updatedCount; 
          } 
           
          scheduleCartSync(null);
           
        }, 
        error: function () { 
          console.error("Failed to fetch updated cart drawer content."); 
        }, 
      }); 
    }, 
    error: function (xhr, status, error) { 
      console.error("Error adding item to cart:", error); 
    }, 
  }); 
   
} 
var jscUpdateVarID = (e,variant_id,selling_plan, check_var) => { 
  //console.log(variant_id); 
  $(e).addClass('jsc-active-btn'); 
  $(e).siblings().removeClass('jsc-active-btn'); 
  var $custom_qb_btn = $(e).parents('.jsc-custom-qb-div').find('.jsc-custom-qb-button'); 
  if (check_var) { 
    $custom_qb_btn.attr('data-var-id',check_var);
  }
  $custom_qb_btn.attr('data-selling-plan',selling_plan); 
  jscCloseCartDrawer(); 

  jscUpdateVarPrice(e,variant_id,selling_plan);
}
var jscCloseCartDrawer = () => {
  
  setTimeout(() => {
    $('html').removeClass('lock');
  }, 1000);
    //console.log('close drawer');
}
var jscUpdateVarPrice = (e,variant_id,selling_plan) => {
  const productVariant = JSON.parse(
    document.querySelector(`.variant-data[data-variant-id="${variant_id}"]`).textContent
  );

  const variant = productVariant.variants?.find(v => v.id == variant_id);

  const variantData = variant ?? productVariant;

  var priceContainer = $(e).parents(".product-card__info").find(".jsc-grid-price").find("sale-price")[0];
  if(!priceContainer){
    priceContainer = $(e).parents(".product-card__info").find(".jsc-grid-price").find(".jsc-alt-price")[0];
  }

  if(!priceContainer) return;

  if (!selling_plan) {
    priceContainer.innerHTML = "$" + (variantData.price / 100).toFixed(2);
    return;
  }

  // Find matching selling plan allocation
  const allocation = variantData.selling_plan_allocations.find(a =>
    a.selling_plan_id == selling_plan
  );

  if (allocation) {
    priceContainer.innerHTML = "$" + (allocation.price / 100).toFixed(2);
  }
}
var jscSelectVarID = (e) => { 
   
  var selling_plan = $(e).val(); 
  if (selling_plan == 'One Time') { 
    selling_plan = ''; 
  } 
  else { 
     
  } 
  var $custom_qb_btn = $(e).parents('.jsc-custom-qb-div').find('.jsc-custom-qb-button'); 
  $custom_qb_btn.attr('data-selling-plan',selling_plan); 
} 
var jscSelectVarID_dropdown = (e) => { 
  $(e).addClass('jsc-active-btn'); 
  $(e).siblings().removeClass('jsc-active-btn'); 
  setTimeout(function(){ 
    var selectedValue = $(e).val(); 
    //console.log('selectedValue',selectedValue); 
    var $custom_qb_btn = $(e).parents('.jsc-custom-qb-div').find('.jsc-custom-qb-button'); 
    $custom_qb_btn.attr('data-selling-plan',selectedValue); 
  },200); 
   
} 
//end: product grid custom quick buy 

//start: show price in ATC button in pdp
var onloadUpdateButtonPrice = () => {
  var $pageUrl;
  var price;
  var activeLabel;
  var $subscription_radio;
  var $onetime_radio;
  var $subscription_widget = $('.recharge-subscription-widget');
  var $pdp_atc_btn;
  var $pdp_atc_btn_price;
  
  if ($subscription_widget.length > 0) {
    
    setInterval(function(){
      $pageUrl = window.location.href;
      //$pdp_atc_btn = $('.jsc-pdp-buy-buttons button div');

      $pdp_atc_btn_price = $('.product-info__buy-buttons .jsc-pdp-buy-buttons button div .jsc-pdp-btn-price');
      if ($pageUrl.includes("selling_plan")) {
        $subscription_radio = $subscription_widget.find("label.subscription-radio");
        activeLabel = $subscription_radio;
      } else {
        $onetime_radio = $subscription_widget.find("label.onetime-radio");
        activeLabel = $onetime_radio;
      }
      
      price = activeLabel.find('.price-label').html();
      $pdp_atc_btn_price.html(price);

      var $pdp_sticky_atc_subsc_plan;
      $pdp_sticky_atc_subsc_plan = $('.jsc-sticky-atc-subscription-plan');
      var $get_selling_plan_from_url = $pageUrl.split("selling_plan=")[1];
      var $get_selling_plan_from_form = $('.product-info__buy-buttons').find('input[name="selling_plan"]').val();
      
      if ($pdp_sticky_atc_subsc_plan.length > 0) {
        $pdp_sticky_atc_subsc_plan.find('.each-subs-plan').each(function(){
          var $this_selling_plan = $(this).attr('data-selling-plan');
          $(this).addClass('d-none');
          if ($this_selling_plan == $get_selling_plan_from_form) {
            $(this).removeClass('d-none');
          }
          //console.log($(this),$get_selling_plan_from_url,$this_selling_plan);
        });
      }

    },500);
    
  }
}
var jscUpdateButtonPrice = (e,price) => {
  var $pdp_atc_btn = $('.product-info__buy-buttons .jsc-pdp-buy-buttons button div');
  $pdp_atc_btn.find('.jsc-pdp-btn-dash').remove();
  $pdp_atc_btn.find('.jsc-pdp-btn-price').remove();

  setTimeout(function(){
    var $pageUrl = window.location.href;
    
    if ($pageUrl.includes("selling_plan")) {
      
      var $recharge_active_btn = $('.rc-radio--active');
      var $recharge_price = $recharge_active_btn.find('.price-label').html();
      //console.log("$recharge_active_btn",$recharge_price);
      price = $recharge_price;
    } else {
        
    }
    
    //$pdp_atc_btn.find('.jsc-pdp-btn-dash').remove();
    //$pdp_atc_btn.find('.jsc-pdp-btn-price').remove();
    $pdp_atc_btn.append('<span class="jsc-pdp-btn-dash">&nbsp;-&nbsp;</span><span class="jsc-pdp-btn-price">' + price + '</span>');

    var $pdp_sticky_atc_subsc_plan;
    $pdp_sticky_atc_subsc_plan = $('.jsc-sticky-atc-subscription-plan');
    var $get_selling_plan_from_url = $pageUrl.split("selling_plan=")[1];
    var $get_selling_plan_from_form = $('.product-info__buy-buttons').find('input[name="selling_plan"]').val();
    
    if ($pdp_sticky_atc_subsc_plan.length > 0) {
      $pdp_sticky_atc_subsc_plan.find('.each-subs-plan').each(function(){
        var $this_selling_plan = $(this).attr('data-selling-plan');
        $(this).addClass('d-none');
        if ($this_selling_plan == $get_selling_plan_from_form) {
          $(this).removeClass('d-none');
        }
        console.log($(this),$get_selling_plan_from_url,$this_selling_plan);
      });
    }
  },200);

}

var updateQuickBuyPrice = (evt) => {
  var $quickBuyInfo = $(evt).closest('.quick-buy-drawer');
  if ($quickBuyInfo.length > 0) {
    setTimeout(() => {
      var price = $quickBuyInfo.find('sale-price .money').text();
      var $atcBtn = $quickBuyInfo.find('.jsc-pdp-buy-buttons button div');
      $atcBtn.append('<span class="jsc-pdp-btn-dash">&nbsp;-&nbsp;</span><span class="jsc-pdp-btn-price">' + price + '</span>');
    }, 200);
  }
}
//end: show price in ATC button in pdp

//start: scroll to attached section 
var jscScrollToMainSection = (scrollTo) => {
  
  //var target = $('.jsc-product-page');
  var target = $("." + scrollTo);
  
  if (target.length) {
      $("html, body").animate({
          scrollTop: target.offset().top - 150 // Adjust for fixed header
          // scrollTop: target.offset().top - 150
      }, 800);
  }
  
}
//end: scroll to attached section
// start: section anchor
getAnchorLink = (e) => {
  var anchorLink = $(e).attr('data-anchor-id');
  scrollToSection(anchorLink);
}
scrollToSection = (link) => {
  var target = $('[data-anchor="' + link + '"]:first');
  if(target.length > 0) {
    var top = target.offset().top - 150;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }
}
// end: section anchor

//start: hover new navigation March 2025
onloadNewNavHover = () => {
  // console.log('onload hover navvvv');
  $('.jsc-second-level-nav-title a').hover(
    function(){ // run this when hover
      var $this_title = $(this).parent().attr('data-second-level-handle');
      var $this_tab = $(this).parent();
      var $other_tab = $(this).parent().siblings('.jsc-second-level-nav-title');
      var $this_thin_arrow = $(this).find('.jsc-menu-arrow-thin');
      var $this_bold_arrow = $(this).find('.jsc-menu-arrow-bold');
      //$this_thin_arrow.hide();
      //$this_bold_arrow.show();
      $other_tab.removeClass('jsc-active-second-nav');
      $this_tab.addClass('jsc-active-second-nav');

      $('.jsc-second-level-content').each(function(){
        var $this_parent_title = $(this).attr('data-second-level-handle')
        $(this).hide();
        //$this_tab.removeClass('jsc-active-second-nav');

        if ($this_parent_title == $this_title) {
          $(this).show();
          
        }
      });
    },
    function () { // run this when outhover
      var $this_title = $(this).attr('data-second-level-handle');
      var $this_thin_arrow = $(this).find('.jsc-menu-arrow-thin');
      var $this_bold_arrow = $(this).find('.jsc-menu-arrow-bold');
      //$this_thin_arrow.show();
      //$this_bold_arrow.hide();
      
      // $('.jsc-second-level-content').each(function(){
      //   $(this).hide();
      // });
      // $('.jsc-second-level-first-content').show();
    }
  );
}
//end: hover new navigation March 2025

cartSubscriptionNote = () => {
  const targetNode = document.querySelector('#cart-drawer');

  if (targetNode) {
    const config = { childList: true, subtree: true };

    const callback = function(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          if (targetNode.querySelector('.jsc-subscription-label')) {
            $('.jsc-subscription-note').removeClass('d-none');
          } else {
            $('.jsc-subscription-note').addClass('d-none');
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
}

//start: show or hide variant button
var setupVariantOption = () => {
  const inputs = $(`input[name="option1"]`);
  inputs.each(function () {
    const val = $(this).val();
    const option1 = $(`.jsc-variant-details:not(.jsc-hidden-variant)[data-option1="${val}"]`);
    
    if (option1.length === 0) {
      $(this).next('.jsc-block-swatch').addClass('jsc-block-swatch-hidden');
    }
  });
}
var controlVariantOption = (e) => {
  const hiddenVariants = $('.jsc-hidden-variant');

  if (hiddenVariants.length > 0) {
    setTimeout(function() {
      var variants = $('input:checked + .jsc-block-swatch'); //:not(.d-none)
      const selected = variants.map((_, el) => {
        const inputId = $(el).attr('for');
        return document.getElementById(inputId)?.value;
      }).get();
 
      // Reset visibility
      $('.jsc-block-swatch').removeClass('d-none');

      hiddenVariants.each(function () {
        const $hiddenVariant = $(this);

        for (let i = 0; i < selected.length; i++) {
          const optionAttr = $hiddenVariant.attr(`data-option${i + 1}`);
          
          if (optionAttr != selected[i] && i != selected.length - 1) {
            break;
          } else if (i == selected.length - 1) {
            const lastOptionValue = $hiddenVariant.attr(`data-option${selected.length}`);
            
            if (lastOptionValue == optionAttr) {
              const input = $(`input[value="${lastOptionValue}"] + .jsc-block-swatch`);
              input.addClass('d-none');
            }
          }
        }
      });

      // if there is any selected hidden variant, then reselect the first available option
      variants = $('input:checked + .jsc-block-swatch.d-none, input:checked + .jsc-block-swatch.jsc-block-swatch-hidden');
      variants.each(function() {
        const $variant = $(this);
        const inputId = $variant.attr('for');
        const $input = $('#' + inputId);
        const inputName = $input.attr('name');

        $(`input[name="${inputName}"] + .jsc-block-swatch:not(.d-none):not(.jsc-block-swatch-hidden)`).first().trigger('click');

        if (inputName == 'option1') {
          return false;
        }
      });
    }, 1000);
  }

  if ($(e).length > 0) {
    var other_variant = $(e).siblings('.jsc-block-swatch');
    if (other_variant.hasClass("jsc-selected-swatch")) {
     other_variant.removeClass('jsc-selected-swatch');
    }
  }
}
//end: show or hide variant button

//start: featured collection tab
var jscSwitchCollectionTab = (collectionId) => {
  $(`.jsc-collection-tab, .jsc-collection-link, .jsc-header-link`).addClass('d-none');
  $(`#jsc-collection-tab-${collectionId}, #jsc-collection-link-${collectionId}, #jsc-header-link-${collectionId}`).removeClass('d-none');
  $(`.jsc-collection-tab-header`).removeClass('active');
  $(`.jsc-collection-tab-header-${collectionId}`).addClass('active');
}
//end: featured collection tab

//start: enable flickity for multicolumn section
var onloadMultiColumnFlickity = ($context) => {
  var $scope = $context ? $($context) : $(document);
  var $jsc_mobile_flickity = $scope.find('.jsc-multi-column-mobile-flickity').add($scope.filter('.jsc-multi-column-mobile-flickity'));
  var $jsc_desktop_flickity = $scope.find('.jsc-multi-column-desktop-flickity').add($scope.filter('.jsc-multi-column-desktop-flickity'));

  if ($jsc_mobile_flickity.length > 0) {
    
    if ($(window).width() < 480) {

      $jsc_mobile_flickity.each(function(){
        var $this = $(this);
        var $slide_limit = $this.attr('data-mobile-flky-limit');

        var flkty = new Flickity(this, {
          cellAlign: 'center',
          contain: true,
          pageDots: true,
          groupCells: $slide_limit,
          imagesLoaded: true,
          wrapAround: true,
          draggable: true,
          prevNextButtons: true,
          // autoPlay: 4000,
           on: {
            ready: function() {
              var self = this;

              if (typeof self.resize === 'function') {
                self.resize();
              }

              setTimeout(function () {
                if (typeof self.resize === 'function') self.resize();
                if (typeof self.reposition === 'function') self.reposition();
              }, 300);

              $($this).addClass('jsc-flickity-initiated');
            }
          }
        });
      });
    }
  }

  if ($jsc_desktop_flickity.length > 0) {
    
    if ($(window).width() > 481) {

      $jsc_desktop_flickity.each(function(){
        var $this = $(this);
        var $slide_limit = $this.attr('data-desktop-flky-limit');

        var flkty = new Flickity(this, {
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          groupCells: $slide_limit,
          imagesLoaded: true,
          wrapAround: true,
          draggable: true,
          prevNextButtons: true,
          // autoPlay: 4000,
          on: {
            ready: function() {
              var self = this;

              if (typeof self.resize === 'function') {
                self.resize();
              }

              setTimeout(function () {
                if (typeof self.resize === 'function') self.resize();
                if (typeof self.reposition === 'function') self.reposition();
              }, 300);

              $($this).addClass('jsc-flickity-initiated');
            }
          }
        });
      });
    }
  }
}
//end: enable flickity for multicolumn section

//start: bundle builder
var getBundleItems = (sectionId) => {
  const storageKey = `bundle_builder_${sectionId}`;
  try {
    const stored = localStorage.getItem(storageKey);
    return stored ? JSON.parse(stored) : [];
  } catch (e) {
    return [];
  }
};

var saveBundleItems = (sectionId, items) => {
  const storageKey = `bundle_builder_${sectionId}`;
  localStorage.setItem(storageKey, JSON.stringify(items));
};

var getBundleSectionSettings = (sectionId) => {
  const section = document.getElementById(`shopify-section-${sectionId}`);
  if (!section) return null;
  
  // Read GWP tier criteria from tier item data attributes
  // data-gwp-tier-criteria on .jsc-bundle-tier-item elements
  let tierCriteria = {};
  const tierItems = section.querySelectorAll('.jsc-bundle-tier-item');
  
  tierItems.forEach((item) => {
    const tierNum = parseInt(item.getAttribute('data-tier')) || 0;
    const criteriaValue = item.getAttribute('data-gwp-tier-criteria');
    if (tierNum > 0 && criteriaValue != null && criteriaValue !== '') {
      tierCriteria[tierNum.toString()] = criteriaValue;
    }
  });
  
  return {
    tierCriteria: tierCriteria
  };
};

var calculateTotal = (items) => {
  return items.reduce((sum, item) => sum + (item.price || 0), 0);
};

var getCurrentTier = (sectionId, combinedTotal) => {
  const settings = getBundleSectionSettings(sectionId);
  if (!settings) return 0;
  
  let currentTier = 0;
  
  for (let i = 1; i <= 10; i++) {
    if (settings.tierCriteria[i]) {
      const threshold = parseFloat(settings.tierCriteria[i]);
      if (combinedTotal >= threshold) {
        currentTier = i;
      }
    }
  }
  return currentTier;
};

var renderBundlePanel = (sectionId) => {
  const settings = getBundleSectionSettings(sectionId);
  if (!settings) {
    console.error('Bundle settings not found for section:', sectionId);
    return;
  }
  
  const items = getBundleItems(sectionId);
  console.log('Rendering bundle panel with items:', items);
  const bundleTotal = calculateTotal(items);
  const totalQuantity = items.length;
  
  // Calculate cart total from hidden fields
  const section = document.getElementById(`shopify-section-${sectionId}`);
  let cartTotal = 0;
  if (section) {
    const cartPriceInputs = section.querySelectorAll('.jsc-cart-item-price');
    cartPriceInputs.forEach((input) => {
      const price = parseFloat(input.value) || 0;
      cartTotal += price;
    });
  }
  
  // Calculate combined total (cart + bundle)
  const combinedTotal = cartTotal + bundleTotal;
  const currentTier = getCurrentTier(sectionId, combinedTotal);
  
  // Update progress info - calculate next tier and value needed
  const progressInfo = document.getElementById(`jsc-bundle-progress-info`);
  if (progressInfo && section) {
    // Get all tier items from both containers
    const allTierItems = Array.from(section.querySelectorAll('.jsc-bundle-tier-item'));
    
    // Find the next unreached tier
    let nextTier = null;
    
    // Sort tiers by threshold value (ascending)
    const sortedTiers = allTierItems
      .map(item => {
        const tierNum = parseInt(item.getAttribute('data-tier')) || 0;
        const tierCriteriaStr = item.getAttribute('data-gwp-tier-criteria');
        const tierCriteria = parseFloat(tierCriteriaStr) || 0;
        const gwpTextEl = item.querySelector('.jsc-bundle-tier-reward');
        const gwpText = gwpTextEl ? gwpTextEl.textContent.trim() : '';
        
        return { tierNum, tierCriteria, gwpText, item };
      })
      .filter(tier => tier.tierCriteria > 0)
      .sort((a, b) => a.tierCriteria - b.tierCriteria);
    
    // Find the first tier that hasn't been reached
    for (const tier of sortedTiers) {
      if (combinedTotal < tier.tierCriteria) {
        nextTier = tier;
        break;
      }
    }
    
    const progressParagraph = progressInfo.querySelector('p');
    if (progressParagraph) {
      if (nextTier && nextTier.tierCriteria) {
        // Calculate how much more value is needed
        // Both tierCriteria and combinedTotal should be in the same unit (cents)
        const valueNeeded = nextTier.tierCriteria - combinedTotal;
        const moneyFormat = $('body').data('money') || window.themeVariables?.settings?.moneyFormat;
        
        // If valueNeeded is negative or zero, show 0
        if (valueNeeded <= 0) {
          progressParagraph.innerHTML = `You've reached all tiers!`;
        } else {
          // formatMoney expects cents, use valueNeeded directly
          const formattedValue = Shopify.formatMoney(valueNeeded, moneyFormat);
          const cleanValue = formattedValue.replace(/<[^>]*>/g, '').trim();
          
          // Update the paragraph with new message
          progressParagraph.innerHTML = `Add <span id="jsc-bundle-items-needed">${cleanValue}</span> more value to get ${nextTier.gwpText}`;
        }
      } else {
        // All tiers reached or no tiers available
        progressParagraph.innerHTML = `You've reached all tiers!`;
      }
    }
  }

  // Update tier progress - handle both tier progress containers
  console.log('=== TIER PROGRESS UPDATE ===');
  console.log('Cart Total:', cartTotal, '| Bundle Total:', bundleTotal, '| Combined Total:', combinedTotal);
  const tierProgressContainers = section ? section.querySelectorAll('.jsc-bundle-tier-progress') : [];
  
  if (tierProgressContainers.length === 0) {
    console.warn('No tier progress containers found');
  }
  
  tierProgressContainers.forEach((tierProgress, containerIndex) => {
    console.log(`Processing container ${containerIndex + 1}`);
    const tierItems = tierProgress.querySelectorAll('.jsc-bundle-tier-item');
    console.log(`Found ${tierItems.length} tier items in container ${containerIndex + 1}`);
    
    tierItems.forEach((item) => {
      // Always start by removing active class
      item.classList.remove('active');
      
      // Use data-tier attribute to get the actual tier number
      const tierNum = parseInt(item.getAttribute('data-tier')) || 0;
      const tierCriteriaStr = item.getAttribute('data-gwp-tier-criteria');
      
      console.log(`Tier ${tierNum} - Raw data-gwp-tier-criteria attribute: "${tierCriteriaStr}"`);
      
      // Validate that tierCriteriaStr exists and is not empty
      if (!tierCriteriaStr || tierCriteriaStr.trim() === '') {
        console.warn(`Tier ${tierNum} has no criteria value - skipping`);
        return;
      }
      
      const tierCriteria = parseFloat(tierCriteriaStr);
      
      // Validate that tierCriteria is a valid number
      if (isNaN(tierCriteria) || tierCriteria <= 0) {
        console.warn(`Tier ${tierNum} has invalid criteria value: "${tierCriteriaStr}" (parsed as ${tierCriteria}) - skipping`);
        return;
      }
      
      const isSatisfied = combinedTotal >= tierCriteria;
      console.log(`Tier ${tierNum}: threshold=${tierCriteria}, combinedTotal=${combinedTotal}, satisfied=${isSatisfied} (${combinedTotal} >= ${tierCriteria})`);
      
      // Check if this tier is satisfied
      // Only activate if combined total is greater than or equal to tierCriteria
      if (isSatisfied) {
        item.classList.add('active');
        console.log(`  → Tier ${tierNum} ACTIVATED`);
      } else {
        console.log(`  → Tier ${tierNum} NOT satisfied`);
      }
    });
  });
  console.log('=== END TIER PROGRESS UPDATE ===');

  // Render slots
  for (let i = 1; i <= 6; i++) {
    const slot = document.getElementById(`jsc-bundle-slot-${i}`);
    if (!slot) {
      console.warn(`Slot ${i} not found`);
      continue;
    }
    
    // Always start by removing active class, then add it back if item exists
    slot.classList.remove('active');
    
    const item = items[i - 1];
    const slotContent = slot.querySelector('.jsc-slot-content');
    const slotNumber = slot.querySelector('.jsc-slot-number');
    const removeBtn = slot.querySelector('.jsc-slot-remove-btn');
    
    if (!slotContent) {
      console.warn(`Slot content not found for slot ${i}`);
      continue;
    }
    
    if (item) {
      const moneyFormat = $('body').data('money') || window.themeVariables?.settings?.moneyFormat;
      const formattedPrice = Shopify.formatMoney(item.price, moneyFormat);
      slotContent.innerHTML = `
        <img src="${item.image}" alt="${item.title}" style="max-width: 100%; height: auto;">
        <div class="jsc-slot-content-printed">
          <p class="text-sm bold prod-title">${item.title}</p>
          <p class="text-xs">(${formattedPrice})</p>
        </div>
      `;
      slot.classList.add('active');
      if (slotNumber) slotNumber.classList.add('d-none');
      if (removeBtn) {
        removeBtn.classList.remove('d-none');
        removeBtn.onclick = () => removeFromBundle(sectionId, i - 1);
      }
    } else {
      slotContent.innerHTML = '<p class="text-subdued">Select Product</p>';
      // active class already removed above
      if (slotNumber) slotNumber.classList.remove('d-none');
      if (removeBtn) {
        removeBtn.classList.add('d-none');
        removeBtn.onclick = null; // Clear onclick handler
      }
    }
  }

  // Update totals
  const sectionEl = document.getElementById(`shopify-section-${sectionId}`);
  const totalPriceEl = sectionEl ? sectionEl.querySelector('#jsc-bundle-total-price') : null;
  if (totalPriceEl) {
    const moneyFormat = $('body').data('money') || window.themeVariables?.settings?.moneyFormat;
    let formattedTotal = Shopify.formatMoney(bundleTotal, moneyFormat);
    formattedTotal = formattedTotal?.replace(/class=money/g, 'class="money"');
    totalPriceEl.innerHTML = formattedTotal;

    const addBundleButton = sectionEl.querySelector('.jsc-bundle-builder-part2 .jsc-add-to-bundle');
    const priceText = formattedTotal.replace(/<[^>]*>/g, '').trim();
    const baseLabel = addBundleButton.dataset.baseLabel || 'Add To Cart';
    addBundleButton.dataset.baseLabel = baseLabel;
    if (window.matchMedia('(max-width: 824px)').matches) {
      addBundleButton.value = `${baseLabel} - ${priceText}`;
    } else {
      addBundleButton.value = baseLabel;
    }

    // Update mobile bundle builder view button
    const mobileBundleButton = sectionEl.querySelector('.jsc-mobile-bundle-builder-view');
    if (mobileBundleButton) {
      mobileBundleButton.innerHTML = `View My Items - ${priceText} <span class="jsc-bundle-builder-arrow"></span>`;
    }
  }

  // Update product count text
  const productCountEl = sectionEl ? sectionEl.querySelector('#jsc-bundle-product-count') : null;
  if (productCountEl) {
    const productText = totalQuantity <= 1 ? 'Product' : 'Products';
    productCountEl.innerHTML = `${totalQuantity} ${productText} Chosen`;
  }
};

var productDataCache = {};
var loadProductData = (handle) => {
  if (!handle) {
    return Promise.resolve(null);
  }
  
  if (!productDataCache[handle]) {
    productDataCache[handle] = fetch(`/products/${handle}.js`)
      .then((response) => response.ok ? response.json() : null)
      .catch((error) => {
        console.warn('Failed to load product data:', error);
        return null;
      });
  }
  
  return productDataCache[handle];
};

var getVariantPreviewImage = (variant) => {
  if (!variant || !variant.featured_media) {
    return '';
  }

  const previewImage = variant.featured_media.preview_image || variant.featured_media;
  const src = previewImage?.src;

  if (!src) {
    return '';
  }

  if (typeof window !== 'undefined' && window.Shopify && window.Shopify.Image && typeof window.Shopify.Image.getSizedImageUrl === 'function') {
    return window.Shopify.Image.getSizedImageUrl(src, '300x');
  }

  return src;
};

var updateModalBundleButtonData = (button, variant, baseTitle, fallbackImage) => {
  if (!button || !variant) {
    return;
  }

  const variantTitle = variant.title && variant.title !== 'Default Title'
    ? `${baseTitle || ''}${baseTitle ? ' - ' : ''}${variant.title}`
    : (baseTitle || variant.title || '');

  button.setAttribute('data-product-title', variantTitle);
  button.setAttribute('data-variant-id', variant.id);
  button.setAttribute('data-product-price', variant.price || 0);

  const variantImage = getVariantPreviewImage(variant) || fallbackImage;
  if (variantImage) {
    button.setAttribute('data-product-image', variantImage);
  }
};

var getModalSelectedVariant = (modalBody, productDataOverride) => {
  if (!modalBody) {
    return null;
  }

  const productData = productDataOverride || modalBody._productData;

  const variantPickerElement = modalBody.querySelector('variant-picker');
  if (variantPickerElement && variantPickerElement.product && Array.isArray(variantPickerElement.product.variants)) {
    try {
      return variantPickerElement.selectedVariant;
    } catch (error) {
      console.warn('Unable to read selectedVariant from variant-picker:', error);
    }
  }

  const selectors = [
    'form[id^="product-form"] input[name="id"]:not([disabled])',
    'form[action*="/cart/add"] input[name="id"]:not([disabled])',
    'form[id^="product-form"] input[name="id"]',
    'form[action*="/cart/add"] input[name="id"]',
    'input[name="id"]'
  ];

  for (const selector of selectors) {
    const input = modalBody.querySelector(selector);
    if (input && input.value) {
      const parsedId = parseInt(input.value, 10);
      const variantId = isNaN(parsedId) ? input.value : parsedId;
      
      if (productData && Array.isArray(productData.variants)) {
        const matchedVariant = productData.variants.find((variant) => `${variant.id}` === `${variantId}`);
        if (matchedVariant) {
          return matchedVariant;
        }
      }
      
      return { id: variantId };
    }
  }

  return null;
};

var syncModalSwatchState = (container) => {
  if (!container) {
    return;
  }

  const optionGroups = container.querySelectorAll('.variant-picker__option-values');
  optionGroups.forEach((group) => {
    group.querySelectorAll('.jsc-selected-swatch').forEach((label) => {
      label.classList.remove('jsc-selected-swatch');
    });

    const checkedInput = group.querySelector('input[name^="option"]:checked');
    if (checkedInput) {
      const activeLabel = group.querySelector(`label[for="${checkedInput.id}"]`);
      if (activeLabel && activeLabel.classList.contains('jsc-block-swatch')) {
        activeLabel.classList.add('jsc-selected-swatch');
      }
    }
  });
};

var initModalVariantInteractions = (modalBody, options = {}) => {
  if (!modalBody) {
    return;
  }

  modalBody.dataset.initialVariantId = options.initialVariantId || modalBody.dataset.initialVariantId || '';

  if (options.productData) {
    modalBody._productData = options.productData;
  }

  const addToBundleBtn = modalBody.querySelector('.jsc-modal-add-to-bundle-btn');
  const baseTitle = options.baseTitle || addToBundleBtn?.getAttribute('data-product-title') || '';
  const fallbackImage = options.fallbackImage || addToBundleBtn?.getAttribute('data-product-image') || '';

  const variantForms = modalBody.querySelectorAll('form[id^="product-form"], form[action*="/cart/add"]');
  variantForms.forEach((form) => {
    const handleVariantChange = (event) => {
      const variant = event?.detail?.variant || getModalSelectedVariant(modalBody, modalBody._productData);
      if (variant) {
        updateModalBundleButtonData(addToBundleBtn, variant, baseTitle, fallbackImage);
      }
      syncModalSwatchState(form);
    };

    form.addEventListener('variant:change', handleVariantChange);

    if (options.initialVariantId) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = options.initialVariantId;
      }
    }

    const optionInputs = form.querySelectorAll('.variant-picker__option-values input[name^="option"]');
    optionInputs.forEach((input) => {
      input.addEventListener('change', () => syncModalSwatchState(form));
    });

    syncModalSwatchState(form);
  });

  const initialVariant = getModalSelectedVariant(modalBody, modalBody._productData);
  if (initialVariant) {
    updateModalBundleButtonData(addToBundleBtn, initialVariant, baseTitle, fallbackImage);
  } else if (addToBundleBtn && !addToBundleBtn.getAttribute('data-variant-id')) {
    addToBundleBtn.setAttribute('data-variant-id', addToBundleBtn.getAttribute('data-product-id') || '');
  }
};

var removeFromBundle = (sectionId, index) => {
  const items = getBundleItems(sectionId);
  items.splice(index, 1);
  saveBundleItems(sectionId, items);
  renderBundlePanel(sectionId);
};

var closeProductModal = (sectionId) => {
  const container = document.getElementById(`jsc-product-modal-container`);
  if (container) {
    container.style.display = 'none';
    document.body.style.overflow = '';
  }
};

var initModalHandlers = (sectionId) => {
  const container = document.getElementById(`jsc-product-modal-container`);
  if (!container) return;

  const modal = document.getElementById(`jsc-product-modal`);
  if (!modal) return;

  // Close button
  const closeBtn = modal.querySelector('.jsc-product-modal-close');
  if (closeBtn) {
    closeBtn.onclick = () => closeProductModal(sectionId);
  }

  // Close on overlay click
  const overlay = container.querySelector('.jsc-product-modal-overlay');
  if (overlay) {
    overlay.onclick = () => closeProductModal(sectionId);
  }

  // Close on ESC key
  const escHandler = (e) => {
    if (e.key === 'Escape' && container.style.display !== 'none') {
      closeProductModal(sectionId);
    }
  };
  document.addEventListener('keydown', escHandler);
  // Store handler for cleanup if needed
  container._escHandler = escHandler;
};

var addBundleToCart = async (sectionId) => {
  const items = getBundleItems(sectionId);
  if (items.length === 0) {
    alert('Please add at least one product to the bundle.');
    return;
  }

  // Generate _BundleId as timestamp + "_" + random string
  const timestamp = Date.now();
  const randomStr = Math.random().toString(36).substring(2, 15);
  const bundleId = `${timestamp}_${randomStr}`;
  const bundleName = document
    .querySelector(`#shopify-section-${sectionId} .jsc-bundle-builder-wrapper[data-bundle-name]`)
    ?.dataset?.bundleName;
  const cartItems = [];

  items.forEach((item, index) => {
    const properties = {
      '_BundleId': bundleId
    };

    if (bundleName) {
      properties['_Bundle_Name'] = bundleName;
    }
    
    const isBundled = index > 0;
    if (isBundled) {
      properties['_Is_Bundled'] = 'true';
      const itemRandomStr = Math.random().toString(36).substring(2, 11);
      properties['_Bundle_Helper'] = `${bundleId}_${index}_${itemRandomStr}`;
    }
    
    // Add each item as a separate cart item with quantity 1
    cartItems.push({
      id: item.variantId,
      quantity: 1,
      properties: properties
    });
  });
  
  console.log('Bundle items for cart (separate items):', cartItems.map(item => ({
    variantId: item.id,
    quantity: item.quantity,
    properties: item.properties
  })));

  // GWP awarding will be handled automatically by the default GWP system
  // (jsc-render-mul-tier-cart.liquid) after items are added to cart

  try {
    // Add all items to cart (bundle items + GWP products)
    for (const cartItem of cartItems) {
      const formData = new FormData();
      formData.append('id', cartItem.id);
      formData.append('quantity', cartItem.quantity);
      
      Object.keys(cartItem.properties).forEach(key => {
        formData.append(`properties[${key}]`, cartItem.properties[key]);
      });

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Failed to add item to cart');
      }
    }

    // Clear bundle after successful add
    saveBundleItems(sectionId, []);
    renderBundlePanel(sectionId);
    
    // Trigger cart update event
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true
    }));

    // Refresh cart drawer to trigger GWP mechanism
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      // Dispatch refresh event
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      
      // Open cart drawer after a short delay to allow GWP mechanism to run
      setTimeout(() => {
        if (typeof cartDrawer.show === 'function') {
          cartDrawer.show();
        }
        // Trigger GWP mechanism after cart drawer is refreshed
        setTimeout(() => {
          if (typeof masterPromo === 'function') {
            masterPromo(false);
          }
        }, 500);
      }, 300);
    }
  } catch (error) {
    console.error('Error adding bundle to cart:', error);
    alert('Error adding bundle to cart: ' + error.message);
  }
};

var initBundleBuilder = (sectionId) => {
  // Initialize modal close handlers
  initModalHandlers(sectionId);

  // Listen for bundle updates
  const updateHandler = (e) => {
    if (e.detail && e.detail.sectionId === sectionId) {
      renderBundlePanel(sectionId);
    }
  };
  document.addEventListener('bundle:updated', updateHandler);

  // Initial render
  renderBundlePanel(sectionId);
};

var jscMobileBundlePanel = (status = 'expand') => {
  const section = document.querySelector('[id^="shopify-section-"][data-jsc-bundle-section-id]');
  const bundlePart2 = section.querySelector('.jsc-bundle-builder-part2');

  if (status === 'expand') {
    bundlePart2.classList.add('expanded');
    getMobileHeight();
  } else {
    bundlePart2.classList.remove('expanded');
  }
  getMobileHeight();
}

var jscAddBundleToCart = () => {
  // Find the bundle builder section
  const section = document.querySelector('[id^="shopify-section-"][data-jsc-bundle-section-id]');
  if (!section) {
    console.error('Bundle builder section not found');
    return;
  }
  
  const sectionId = section.dataset.jscBundleSectionId || section.id.replace('shopify-section-', '');
  addBundleToCart(sectionId);
};

var jscAddToBundle = (button) => {
  if (!button) return;
  
  if (button.disabled) return;
  button.disabled = true;
  
  setTimeout(() => {
    button.disabled = false;
  }, 500);
  
  const section = $(button).closest('[id^="shopify-section-"]');
  if (!section.length) {
    console.error('Bundle builder section not found');
    button.disabled = false;
    return;
  }
  
  const sectionId = section.attr('id').replace('shopify-section-', '');
  const storageKey = `bundle_builder_${sectionId}`;
  
  const productData = {
    variantId: $(button).attr('data-variant-id'),
    handle: $(button).attr('data-product-handle'),
    title: $(button).attr('data-product-title'),
    price: parseInt($(button).attr('data-product-price')) || 0,
    image: $(button).attr('data-product-image')
  };
  
  console.log('Adding product to bundle:', productData);
  console.log('Section ID:', sectionId);
  
  // Get current bundle items
  const items = getBundleItems(sectionId);
  console.log('Current bundle items before add:', items);
  
  // Check if bundle is full
  if (items.length >= 6) {
    alert('Bundle is full. Please remove an item first.');
    button.disabled = false;
    return;
  }
  
  // Add item to bundle (allow duplicates)
  items.push({
    variantId: productData.variantId,
    handle: productData.handle,
    title: productData.title,
    price: productData.price,
    image: productData.image
  });
  
  console.log('Bundle items after add:', items);
  
  // Save to localStorage
  saveBundleItems(sectionId, items);
  
  // Render bundle panel immediately
  renderBundlePanel(sectionId);
  
  // Dispatch event to trigger bundle panel update (for other listeners)
  document.dispatchEvent(new CustomEvent('bundle:updated', {
    detail: { sectionId: sectionId }
  }));
};

var jscQuickView = (button) => {
  if (!button) return;
  
  // Find the bundle builder section
  const section = $(button).closest('[id^="shopify-section-"]');
  if (!section.length) {
    console.error('Bundle builder section not found');
    return;
  }
  
  const sectionId = section.attr('id').replace('shopify-section-', '');
  const sectionElement = section[0]; // Store the actual DOM element
  const productHandle = $(button).attr('data-product-handle');
  const initialVariantId = $(button).attr('data-variant-id');
  const initialVariantTitle = $(button).attr('data-variant-title');
  const initialVariantPrice = $(button).attr('data-variant-price');
  const initialVariantImage = $(button).attr('data-variant-image');
  
  if (!productHandle) {
    console.error('Product handle not found');
    return;
  }
  
  // Get modal elements
  const container = document.getElementById(`jsc-product-modal-container`);
  const modal = document.getElementById(`jsc-product-modal`);
  const modalBody = document.getElementById(`jsc-product-modal-body`);
  
  if (!container || !modal || !modalBody) {
    console.error('Product modal not found');
    return;
  }
  
  // Show modal
  container.style.display = 'block';
  document.body.style.overflow = 'hidden';
  
  // Show loading state
  modalBody.innerHTML = '<div class="jsc-product-modal-loading"><p>Loading product...</p></div>';
  
  // Fetch and load product
  const productFetchUrl = initialVariantId ? `/products/${productHandle}?variant=${initialVariantId}` : `/products/${productHandle}`;
  
  fetch(productFetchUrl)
    .then(response => {
      if (!response.ok) throw new Error('Failed to load product');
      return response.text();
    })
    .then(html => {
      // Debug: log first 500 chars of HTML to see structure
      console.log('Fetched HTML preview:', html.substring(0, 500));
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Debug: check for parse errors
      const parseError = doc.querySelector('parsererror');
      if (parseError) {
        console.error('HTML Parse Error:', parseError.textContent);
        throw new Error('Failed to parse product HTML');
      }
      
      // Get product section - try multiple selectors
      let productSection = doc.querySelector('.shopify-section--main-product');
      if (!productSection) {
        // Try with ID selector
        productSection = doc.querySelector('[id*="shopify-section"][class*="main-product"]');
      }
      if (!productSection) {
        productSection = doc.querySelector('[class*="main-product"]');
      }
      if (!productSection) {
        // Try finding by product class
        productSection = doc.querySelector('.product.jsc-product-page')?.closest('[class*="section"]') || doc.querySelector('.product');
      }
      if (!productSection) {
        productSection = doc.querySelector('main');
      }
      
      if (!productSection) {
        console.error('Product section not found. Available sections:', Array.from(doc.querySelectorAll('[class*="section"]')).map(el => ({
          className: el.className,
          id: el.id,
          tagName: el.tagName
        })));
        throw new Error('Product section not found');
      }
      
      console.log('Found product section:', {
        className: productSection.className,
        id: productSection.id
      });
      
      // Extract product gallery and info - try multiple selectors
      // First try within the section, then try the whole document
      let productGallery = productSection.querySelector('.product-gallery');
      if (!productGallery) {
        productGallery = productSection.querySelector('product-gallery');
      }
      if (!productGallery) {
        productGallery = doc.querySelector('.product-gallery');
      }
      if (!productGallery) {
        productGallery = doc.querySelector('product-gallery');
      }
      
      let productInfo = productSection.querySelector('.product-info');
      if (!productInfo) {
        productInfo = productSection.querySelector('safe-sticky.product-info');
      }
      if (!productInfo) {
        productInfo = productSection.querySelector('[class*="product-info"]');
      }
      if (!productInfo) {
        productInfo = doc.querySelector('.product-info');
      }
      if (!productInfo) {
        productInfo = doc.querySelector('safe-sticky.product-info');
      }
      if (!productInfo) {
        productInfo = doc.querySelector('[class*="product-info"]');
      }
      
      // If productInfo is not found, we can still proceed with button data
      if (!productInfo) {
        console.warn('Product info not found, using button data. Available elements:', Array.from(productSection.querySelectorAll('[class*="product"]')).map(el => ({
          className: el.className,
          tagName: el.tagName
        })));
        // Create a dummy productInfo element to avoid errors
        productInfo = document.createElement('div');
        productInfo.className = 'product-info';
      }
      
      console.log('Found product info:', {
        className: productInfo.className,
        hasGallery: !!productGallery,
        productHandle: productHandle
      });
      
      // Extract product data - use optional chaining and fallbacks
      // First try to get from productInfo, then fallback to button data
      const productTitleEl = productInfo.querySelector('.product-info__title') || productInfo.querySelector('h1') || productInfo.querySelector('h2');
      let productTitle = productTitleEl?.textContent?.trim() || productTitleEl?.innerText?.trim() || '';
      if (!productTitle) {
        productTitle = $(button).attr('data-product-title') || '';
      }
      
      // Try to get full price-list structure first (includes compare_at_price)
      let productPriceEl = productInfo.querySelector('price-list');
      if (!productPriceEl) {
        productPriceEl = productInfo.querySelector('.product-info__price') || productInfo.querySelector('[class*="price"]');
      }
      let productPrice = productPriceEl?.outerHTML || productPriceEl?.innerHTML || '';
      if (!productPrice) {
        const priceValue = $(button).attr('data-product-price') || '0';
        productPrice = `<div class="price">${priceValue}</div>`;
      }
      
      // Try multiple ways to find description
      let productDescriptionEl = productInfo.querySelector('.product-info__description');
      if (!productDescriptionEl) {
        // Try text blocks that might contain description
        productDescriptionEl = productInfo.querySelector('.product-info__text');
      }
      if (!productDescriptionEl) {
        // Try collapsible text blocks
        productDescriptionEl = productInfo.querySelector('.product-info__accordion');
      }
      
      let productDescription = '';
      if (productDescriptionEl) {
        // Get the entire description block HTML (including prose wrapper if it exists)
        productDescription = productDescriptionEl.innerHTML;
        console.log('Found product description:', productDescription.substring(0, 100));
      } else {
        console.log('Product description element not found. Available elements:', 
          Array.from(productInfo.querySelectorAll('[class*="product-info"]')).map(el => el.className));
      }
      
      const variantPickerEl = productInfo.querySelector('variant-picker');
      const variantPicker = variantPickerEl?.outerHTML || '';
      
      const buyButtonsEl = productInfo.querySelector('.product-info__buy-buttons') || productInfo.querySelector('[class*="buy-button"]');
      const buyButtons = '';
      
      // Extract images from gallery
      let allImages = [];
      if (productGallery) {
        // Try to get images from various possible structures
        // Exclude images from badge containers
        const galleryImages = productGallery.querySelectorAll('img:not(.jsc-product-badge-container img)');
        if (galleryImages.length > 0) {
          // Filter out any images that are inside badge containers
          allImages = Array.from(galleryImages).filter(img => {
            return !img.closest('.jsc-product-badge-container');
          });
        } else {
          // Try to get from media elements
          const mediaElements = productGallery.querySelectorAll('[data-media-id], picture img, .product-media img');
          // Filter out badge images
          allImages = Array.from(mediaElements).filter(img => {
            return !img.closest('.jsc-product-badge-container');
          });
        }
      }
      
      // If no images found in gallery, try to get from product info
      if (allImages.length === 0) {
        const infoImages = productInfo.querySelectorAll('img:not(.jsc-product-badge-container img)');
        // Filter out any images that are inside badge containers
        allImages = Array.from(infoImages).filter(img => {
          return !img.closest('.jsc-product-badge-container');
        });
      }
      
      const mainImage = allImages[0] || null;
      const thumbnails = allImages.slice(1) || [];
      
      // Extract badge container from gallery
      let badgeContainer = '';
      if (productGallery) {
        const badgeContainerEl = productGallery.querySelector('.jsc-product-badge-container');
        if (badgeContainerEl) {
          badgeContainer = badgeContainerEl.outerHTML;
        }
      }
      // If not found in gallery, try product info
      if (!badgeContainer && productInfo) {
        const badgeContainerEl = productInfo.querySelector('.jsc-product-badge-container');
        if (badgeContainerEl) {
          badgeContainer = badgeContainerEl.outerHTML;
        }
      }
      
      // Build modal content with new layout
      let modalContent = '<div class="jsc-product-modal-layout">';
      
      // Prepare combined image list for thumbnails and slider
      const combinedImages = allImages && allImages.length ? allImages : (mainImage ? [mainImage, ...thumbnails] : thumbnails);
      const hasImages = combinedImages.length > 0;
      const hasMultipleImages = combinedImages.length > 1;
      const modalCarouselId = `jsc-modal-media-carousel-${sectionId}-${productHandle}`;
      
      // Left sidebar: Thumbnails
      modalContent += '<div class="jsc-product-modal-thumbnails">';
      if (hasImages) {
        combinedImages.forEach((imageEl, index) => {
          const isActive = index === 0 ? ' active' : '';
          modalContent += `<div class="jsc-thumbnail-item${isActive}" data-image-index="${index}">${imageEl.outerHTML}</div>`;
        });
      }
      modalContent += '</div>';
      
      // Center: Main product image slider
      modalContent += '<div class="jsc-product-modal-main-image">';
      if (hasImages) {
        modalContent += '<div class="jsc-main-image-slider">';
        modalContent += `<button type="button" class="jsc-slider-nav jsc-slider-nav--prev"${hasMultipleImages ? '' : ' disabled'} aria-label="Previous image">&lsaquo;</button>`;
        modalContent += '<div class="jsc-main-image-wrapper">';
        if (badgeContainer) {
          modalContent += badgeContainer;
        }
        modalContent += `<media-carousel id="${modalCarouselId}" class="jsc-modal-media-carousel scroll-area" adaptive-height initial-index="0">`;
        combinedImages.forEach((imageEl, index) => {
          const isSelected = index === 0 ? ' is-selected' : '';
          modalContent += `<div class="jsc-modal-media-slide snap-center${isSelected}" data-media-type="image" data-image-index="${index}">${imageEl.outerHTML}</div>`;
        });
        modalContent += '</media-carousel>'; // end carousel

        if (hasMultipleImages) {
          modalContent += `<page-dots class="page-dots page-dots--blurred jsc-modal-page-dots" aria-controls="${modalCarouselId}">`;
          combinedImages.forEach((_, index) => {
            modalContent += `<button type="button" class="tap-area" aria-current="${index === 0 ? 'true' : 'false'}"><span class="sr-only">Go to item ${index + 1}</span></button>`;
          });
          modalContent += `</page-dots>`;
        }
        modalContent += '</div>'; // end wrapper
        modalContent += `<button type="button" class="jsc-slider-nav jsc-slider-nav--next"${hasMultipleImages ? '' : ' disabled'} aria-label="Next image">&rsaquo;</button>`;
        modalContent += '</div>'; // end slider
      }
      modalContent += '</div>'; // end main image area
      
      // Right sidebar: Product details - use product-info wrapper for default styling
      modalContent += '<div class="jsc-product-modal-details">';
      modalContent += '<safe-sticky class="product-info">';
      
      // Title - use product-info__title class
      if (productTitle) {
        modalContent += `<h2 class="product-info__title h2">${productTitle}</h2>`;
      }
      
      // Price - use product-info__price class
      if (productPrice) {
        modalContent += `<div class="product-info__price">${productPrice}</div>`;
      }
      
      // Description - use product-info__description class
      // The description should already include the prose wrapper from the original HTML
      if (productDescription) {
        modalContent += `<div class="product-info__description">${productDescription}</div>`;
      } else {
        console.warn('Product description is empty, skipping description block');
      }
      
      // Key Features Section - try to extract from description or metafields
      // Look for bullet points or list items in description
      let keyFeatures = '';
      if (productDescriptionEl) {
        const listItems = productDescriptionEl.querySelectorAll('ul li, ol li');
        if (listItems.length > 0) {
          keyFeatures = '<div class="product-info__key-features">';
          keyFeatures += '<ul class="key-features-list">';
          listItems.forEach(li => {
            const text = li.textContent?.trim();
            if (text) {
              keyFeatures += `<li>${text}</li>`;
            }
          });
          keyFeatures += '</ul>';
          keyFeatures += '</div>';
        }
      }
      if (keyFeatures) {
        modalContent += keyFeatures;
      }
      
      // Packaging Details - try to extract from description or variant title
      // This can be enhanced later with metafields
      let packagingDetails = '';
      // Look for packaging text in description (e.g., "contains", "sachets", "pack")
      if (productDescriptionEl) {
        const descText = productDescriptionEl.textContent || '';
        const packagingPatterns = [
          /(\d+\s*(pack|sachet|piece|item).*?contains.*?\d+)/i,
          /(contains.*?\d+.*?(sachet|pack|piece|item))/i,
          /(\d+\s*x\s*\d+.*?(sachet|pack|piece|item))/i
        ];
        for (const pattern of packagingPatterns) {
          const match = descText.match(pattern);
          if (match) {
            packagingDetails = `<div class="product-info__packaging-details"><p class="text-sm">${match[1]}</p></div>`;
            break;
          }
        }
      }
      if (packagingDetails) {
        modalContent += packagingDetails;
      }
      
      // Variant picker - use product-info__variant-picker class
      if (variantPicker) {
        modalContent += `<div class="product-info__variant-picker">${variantPicker}</div>`;
      }
      
      // Quantity selector - use product-info__quantity-selector and quantity-selector classes
      // Get form ID from variant picker or create one
      const variantPickerElForForm = productInfo.querySelector('variant-picker');
      const formIdFromPicker = variantPickerElForForm?.getAttribute('form') || `product-form-${productHandle}`;
      // Quantity + ATB (keep on one row, mobile sticky footer)
      modalContent += '<div class="jsc-modal-atc-and-qty">';
      modalContent += '<div class="product-info__quantity-selector">';
      modalContent += '<div class="form-control">';
      modalContent += '<quantity-selector class="quantity-selector">';
      modalContent += '<button type="button" class="quantity-selector__button" aria-label="Decrease quantity">';
      modalContent += '<svg width="10" height="2" viewBox="0 0 10 2" fill="none"><path d="M0 1h10" stroke="currentColor" stroke-width="1.5"/></svg>';
      modalContent += '</button>';
      modalContent += `<input id="jsc-modal-quantity" type="text" is="quantity-input" inputmode="numeric" class="quantity-selector__input" name="quantity" form="${formIdFromPicker}" size="2" value="1" autocomplete="off">`;
      modalContent += '<button type="button" class="quantity-selector__button" aria-label="Increase quantity">';
      modalContent += '<svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M5 0v10M0 5h10" stroke="currentColor" stroke-width="1.5"/></svg>';
      modalContent += '</button>';
      modalContent += '</quantity-selector>';
      modalContent += '</div>';
      modalContent += '</div>';
      
      // Add to Bundle button area
      const productId = $(button).attr('data-product-id') || '';
      const productTitleAttr = initialVariantTitle || $(button).attr('data-product-title') || productTitle;
      const productPriceAttr = initialVariantPrice || $(button).attr('data-product-price') || '';
      const productImageAttr = initialVariantImage || $(button).attr('data-product-image') || '';
      const productVariantAttr = initialVariantId || $(button).attr('data-variant-id') || '';

      const bundleFormContent = `
        <form method="post"
              action="/cart/add"
              id="${formIdFromPicker}"
              class="product-form jsc-modal-hidden-product-form"
              data-product-id="${productId}"
              style="display:none;">
          <input type="hidden" name="id" value="${productVariantAttr}">
        </form>
      `;

      modalContent += bundleFormContent;
      modalContent += `
        <div class="jsc-modal-bundle-button">
          <button type="button"
                  class="button button--xl w-full jsc-modal-add-to-bundle-btn cursor"
                  data-section-id="${sectionId}"
                  data-product-handle="${productHandle}"
                  data-product-id="${productId}"
                  data-product-title="${productTitleAttr}"
                  data-product-price="${productPriceAttr}"
                  data-product-image="${productImageAttr}"
                  data-variant-id="${productVariantAttr}">
            Add to Bundle
          </button>
        </div>
      `;
      modalContent += '</div>'; // End .jsc-modal-atc-and-qty
      
      
      modalContent += '</safe-sticky>'; // End product-info
      
      modalContent += '</div>'; // End details
      modalContent += '</div>'; // End layout
      
      modalBody.innerHTML = modalContent;
      modalBody._productData = null;
      modalBody.dataset.initialVariantId = initialVariantId || '';
      initModalVariantInteractions(modalBody, {
        baseTitle: productTitle,
        fallbackImage: productImageAttr,
        initialVariantId: productVariantAttr
      });
      
      loadProductData(productHandle).then((productData) => {
        if (productData) {
          modalBody._productData = productData;
          const addToBundleBtn = modalBody.querySelector('.jsc-modal-add-to-bundle-btn');
          const targetVariantId = modalBody.dataset.initialVariantId;
          let currentVariant = null;

          if (targetVariantId) {
            currentVariant = productData.variants?.find((variant) => `${variant.id}` === `${targetVariantId}`) || null;
          }

          if (!currentVariant) {
            currentVariant = getModalSelectedVariant(modalBody, productData);
          }

          if (addToBundleBtn && currentVariant) {
            updateModalBundleButtonData(addToBundleBtn, currentVariant, productTitle, productImageAttr);
          }
        }
      });
      
      // Initialize slider + thumbnail interactions
      const thumbnailItems = modalBody.querySelectorAll('.jsc-thumbnail-item');
      const escapedCarouselId = (window.CSS && typeof window.CSS.escape === 'function') ? window.CSS.escape(modalCarouselId) : modalCarouselId;
      const mediaCarousel = modalBody.querySelector(`#${escapedCarouselId}`);
      const prevNav = modalBody.querySelector('.jsc-slider-nav--prev');
      const nextNav = modalBody.querySelector('.jsc-slider-nav--next');

      const setActiveThumbnail = (index) => {
        if (!thumbnailItems?.length) return;
        thumbnailItems.forEach((thumb, idx) => {
          thumb.classList.toggle('active', idx === index);
          thumb.setAttribute('aria-current', idx === index ? 'true' : 'false');
        });

        // If thumbnail list overflows, keep active thumb in view (desktop vertical list)
        const activeThumb = thumbnailItems[index];
        if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
          activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      };

      if (mediaCarousel) {
        // Sync thumbnail active state with carousel selection
        mediaCarousel.addEventListener('carousel:change', (event) => {
          const index = event?.detail?.index ?? mediaCarousel.selectedIndex ?? 0;
          setActiveThumbnail(index);
        });
        setActiveThumbnail(mediaCarousel.selectedIndex ?? 0);
      }

      if (prevNav && mediaCarousel && mediaCarousel.items?.length > 1) {
        prevNav.addEventListener('click', () => mediaCarousel.previous());
      }
      if (nextNav && mediaCarousel && mediaCarousel.items?.length > 1) {
        nextNav.addEventListener('click', () => mediaCarousel.next());
      }
      
      if (thumbnailItems.length) {
        thumbnailItems.forEach((thumb) => {
          thumb.addEventListener('click', function() {
            const targetIndex = parseInt(this.dataset.imageIndex || '0', 10) || 0;
            if (mediaCarousel && typeof mediaCarousel.select === 'function') {
              mediaCarousel.select(targetIndex);
            }
            setActiveThumbnail(targetIndex);
          });
        });
      }
      
      // Quantity selector is handled by the quantity-selector custom element
      // No need for manual handlers as the element handles it
      
      // Initialize Add to Bundle button
      const addToBundleBtn = modalBody.querySelector('.jsc-modal-add-to-bundle-btn');
      if (addToBundleBtn) {
        addToBundleBtn.addEventListener('click', function() {
          // Get quantity from the quantity selector input
          const quantityInputEl = modalBody.querySelector('#jsc-modal-quantity') || modalBody.querySelector('.quantity-selector__input');
          const quantity = parseInt(quantityInputEl?.value) || 1;
          
          // Determine currently selected variant
          const activeVariant = getModalSelectedVariant(modalBody, modalBody._productData);
          let selectedVariantId = activeVariant?.id || '';
          if (!selectedVariantId) {
            const variantIdAttr = this.getAttribute('data-variant-id');
            if (variantIdAttr) {
              const parsedVariantId = parseInt(variantIdAttr, 10);
              selectedVariantId = isNaN(parsedVariantId) ? variantIdAttr : parsedVariantId;
            }
          }
          
          if (!selectedVariantId) {
            alert('Please select a variant before adding to the bundle.');
            return;
          }
          
          // Get sectionId from button data attribute (fallback) or closure
          const buttonSectionId = this.getAttribute('data-section-id') || sectionId;
          
          console.log('Adding to bundle from modal:', {
            productId: this.getAttribute('data-product-id'),
            variantId: selectedVariantId,
            quantity: quantity,
            sectionId: buttonSectionId,
            sectionIdFromClosure: sectionId
          });
          
          // Check if required functions exist
          if (typeof getBundleItems !== 'function' || typeof saveBundleItems !== 'function' || typeof renderBundlePanel !== 'function') {
            console.error('Bundle functions not available:', {
              getBundleItems: typeof getBundleItems,
              saveBundleItems: typeof saveBundleItems,
              renderBundlePanel: typeof renderBundlePanel
            });
            alert('Error: Bundle functions not loaded. Please refresh the page.');
            return;
          }
          
          // Get product data
          const productData = {
            variantId: selectedVariantId,
            handle: this.getAttribute('data-product-handle'),
            title: this.getAttribute('data-product-title'),
            price: parseInt(this.getAttribute('data-product-price')) || 0,
            image: this.getAttribute('data-product-image')
          };
          
          // Get current bundle items
          const items = getBundleItems(buttonSectionId);
          console.log('Current bundle items before add:', items);
          
          // Check if bundle is full
          if (items.length + quantity > 6) {
            alert('Bundle is full. Please remove an item first.');
            return;
          }
          
          // Add items to bundle (quantity can be > 1)
          for (let i = 0; i < quantity; i++) {
            items.push({
              variantId: productData.variantId,
              handle: productData.handle,
              title: productData.title,
              price: productData.price,
              image: productData.image
            });
          }
          
          console.log('Bundle items after add:', items);
          
          // Save to localStorage
          saveBundleItems(buttonSectionId, items);
          
          // Render bundle panel immediately
          renderBundlePanel(buttonSectionId);
          
          // Dispatch event to trigger bundle panel update
          document.dispatchEvent(new CustomEvent('bundle:updated', {
            detail: { sectionId: buttonSectionId }
          }));
          
          // Close modal after adding
          setTimeout(() => {
            const container = document.getElementById('jsc-product-modal-container');
            if (container) {
              container.style.display = 'none';
              document.body.style.overflow = '';
            }
          }, 300);
        });
      }
      
      // Reinitialize variant pickers
      // Wait a bit for the DOM to be ready before initializing
      setTimeout(() => {
        const variantPickers = modalBody.querySelectorAll('variant-picker');
        variantPickers.forEach(picker => {
          try {
            // Check if the picker is a custom element and has the method
            if (picker && typeof picker.connectedCallback === 'function') {
              // Ensure the element is connected to the DOM
              if (!picker.isConnected) {
                console.warn('Variant picker not connected to DOM');
                return;
              }
              picker.connectedCallback();
            } else if (picker && picker.connectedCallback) {
              // Try calling it anyway if it exists
              picker.connectedCallback();
            }
          } catch (error) {
            console.warn('Error initializing variant picker:', error);
            // Continue with other pickers even if one fails
          }
        });
      }, 100);
      
      // Close button is handled by the main modal close button handler (initModalHandlers)
    })
    .catch(error => {
      console.error('Error loading product:', error);
      console.error('Error details:', {
        message: error.message,
        stack: error.stack,
        productHandle: productHandle
      });
      modalBody.innerHTML = `<div class="jsc-product-modal-loading"><p>Error loading product: ${error.message}. Please try again.</p></div>`;
    });
};
var getMobileHeight = () => {
  if ($(window).width() < 480) {
    var screenHeight = $(window).height();
    var announcementBanner = $('.shopify-section--announcement-bar').height();
    var megaMenu = $('.shopify-section--header').height();
    var headerHeight = announcementBanner + megaMenu;
    var popup = $('.jsc-bundle-builder-part2.jsc-mobile-sticky-bundle-builder.expanded');
    var popupHeight = popup.height();

    var heightAllowed = screenHeight - headerHeight;
    if (popupHeight >= heightAllowed) {
      console.log('scroll popup');
      var newPopupHeight = heightAllowed ;
      popup.css({
        height: heightAllowed
      });

      var middleContentHeight = newPopupHeight - 50;
      $('.jsc-bundle-builder-middle').css({
        paddingBottom: '50px',
        height: middleContentHeight,
        overflowY: 'auto'
      });
      // $('.jsc-bundle-builder-part2.jsc-mobile-sticky-bundle-builder.expanded').height(heightAllowed);
    } else {
      console.log('full height popup');
    }
    var $el = $('.jsc-bundle-builder-part2');

    if (!$el.hasClass('expanded')) {
      console.log('remove popup height');
      $el.attr('style','');
      $el.find('.jsc-bundle-builder-middle').attr('style','');
    }
    
    
  }
}
//end: bundle builder


var destroyMultiColumnFlickityInstances = ($elements) => {
  var destroyedCount = 0;

  if (typeof Flickity === 'undefined') {
    return destroyedCount;
  }

  $elements.each(function(){
    var instance = Flickity.data(this);

    if (instance) {
      instance.destroy();
      destroyedCount++;
    }

    $(this).removeClass('jsc-flickity-initiated');
  });

  return destroyedCount;
}

var refreshMultiColumnFlickity = ($context) => {
  var $scope = $context ? $($context) : $(document);

  if ($scope.length === 0) {
    return;
  }

  var $mobileCarousels = $scope.find('.jsc-multi-column-mobile-flickity').add($scope.filter('.jsc-multi-column-mobile-flickity'));
  var $desktopCarousels = $scope.find('.jsc-multi-column-desktop-flickity').add($scope.filter('.jsc-multi-column-desktop-flickity'));

  var destroyedMobile = destroyMultiColumnFlickityInstances($mobileCarousels.filter('.jsc-flickity-initiated'));
  var destroyedDesktop = destroyMultiColumnFlickityInstances($desktopCarousels.filter('.jsc-flickity-initiated'));
  var totalDestroyed = destroyedMobile + destroyedDesktop;

  var needsInit = $mobileCarousels.filter(':not(.jsc-flickity-initiated)').length > 0 || $desktopCarousels.filter(':not(.jsc-flickity-initiated)').length > 0;

  if (totalDestroyed > 0 || needsInit) {
    setTimeout(() => {
      onloadMultiColumnFlickity($scope);
    }, 50);
  }
}

var multiColumnSectionObserver = null;

var observeMultiColumnSections = ($sections) => {
  if (!multiColumnSectionObserver || !$sections || !$sections.length) {
    return;
  }

  $sections.each(function(){
    multiColumnSectionObserver.observe(this);
  });
}

var setupMultiColumnIntersectionObserver = () => {
  if (typeof window === 'undefined' || typeof window.IntersectionObserver === 'undefined') {
    return;
  }

  if (multiColumnSectionObserver) {
    multiColumnSectionObserver.disconnect();
  }

  multiColumnSectionObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        refreshMultiColumnFlickity($(entry.target));
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px -100px 0px',
    threshold: 0.1
  });

  observeMultiColumnSections($('.shopify-section--multi-column'));
}

$(window).on('load', function() {
  refreshMultiColumnFlickity();
});

document.addEventListener('shopify:section:load', function(event) {
  var $section = $(event.target).closest('.shopify-section');
  if ($section.length) {
    refreshMultiColumnFlickity($section);
    observeMultiColumnSections($section.filter('.shopify-section--multi-column'));
  }
});

document.addEventListener('shopify:section:select', function(event) {
  var $section = $(event.target).closest('.shopify-section');
  if ($section.length) {
    refreshMultiColumnFlickity($section);
  }
});

window.reorderATC = (evt) => {
  if ($(evt).attr('order-items') != '') {
    var orderItems = $(evt).attr('order-items').split(',');
    for (var item of orderItems) {
      var variantId = parseInt(item.split(':')[0]);
      var quantity = parseInt(item.split(':')[1]);
      
      if (!isNaN(variantId) && !isNaN(quantity)) {
        var product = {
          'id': variantId,
          'quantity': quantity
        };
        cartJSAddQuery(product.id, product.quantity);
      }
    }
  }
}